/* 
Author:Lamiaa Moustafa
Desc: background images styled components 
*/

import styled from "styled-components";
import img from "../../assets/pngs/landing_bg.png";
import LeftImage from "../../assets/pngs/Firefighter.png";
import Clouds from "../../assets/pngs/protectedBg-02.png";

// landing background image
export const BackgroundImage = styled.div`
  height: 97vh;
  width: 100%;
  background-image: url(${img});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  padding: 1% 5%;
  font-family: var(--fontFamily);
  @media (max-width: 768px) {
    height: 95vh;
    padding: 5px;
  }
`;

// Protected route background image
export const ProtectedBG = styled.section`
  height: 90vh;
  width: 100%;
  background-image: url(${Clouds});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 1% 5%;
  font-family: var(--fontFamily);
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    position: relative;
    align-items: flex-start;
    height: 100vh;
    padding: 20px 5px;
  }
`;

export const ImageDiv = styled.div`
  width: 40%;
  height: 100vh;
  background-image: url(${LeftImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @media (max-width: 768px) {
    display: none;
  }
`;
